<template>
<div class="container">
    <!-- <div style="height:10px;background:#f7f7f7;"></div> -->
    <div class="tab">
        <ul class="tab_button">
            <li v-for="(item, index) in cmsData" :key="index" :class="{ active: currentClass == index }" @click="toggleTab(index)">
                <div>
                    <span>{{ item.name }}</span>
                </div>
            </li>
        </ul>
    </div>
    <div class="tab_con tabone">
        <div class="swiper-container">
            <!-- 这边的两个方法是鼠标移入和移出 -->
            <ul class="swiper-wrapper">
                <li class="swiper-slide" v-for="(item, index) in productList[currentTab]" :key="index" @click="detail(item.id)">
                    <div class="swiper-item">
                        <img class="pro-img" :src="item.pictureUrl" alt="" width="100%" />
                        <div class="swiper-bottom">
                            <div class="bottom-content">
                                <div class="swiper-title">{{ item.chineseName }}</div>
                                <!-- <div class="swiper-title">积分价：</div> -->
                                <div>
                                    <!-- <div class="swiper-exchange">积分兑换:</div> -->
                                    <div style="color:#D1504F;">{{ item.integralNum }}积分</div>
                                </div>
                            </div>
                            <!-- <img class="img-back" src="@/assets/icon/hot_bottom.png" /> -->
                        </div>
                    </div>
                    <!-- <div class="swiper">
            <div class="swiper-item titles">{{ item.title }}</div>
            <div class="swiper-item integral">{{ item.integral }}积分</div>
            <div class="swiper-item xian"></div>
            <div class="btn"><span>立即兑换</span></div>
          </div> -->
                </li>
            </ul>
            <!-- 如果需要导航按钮 -->
            <!-- <div class="swiper-button-prev"></div>

<div class="swiper-button-next"></div> -->
            <!-- 指示点 -->
            <!-- <div class="swiper-pagination"></div> -->
            <!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
        </div>
    </div>
</div>
</template>

<script>
import {
    queryByProductId
} from "@/api/api";
import Swiper from "swiper";
export default {
    props: ["cmsData"],
    data() {
        return {
            currentTab: 0,
            currentClass: 0,
            productList: [],
        };
    },
    mounted() {
        this.queryProduct();
        // this.swiper = new Swiper(".swiper-container", {
        //     //   autoplay: {
        //     //     delay: 5000,
        //     //     disableOninteraction: true,
        //     //   },
        //     pagination: {
        //         //指示点
        //         el: ".swiper-pagination",
        //     },
        //     observer: true, //修改swiper自己或子元素时，自动初始化swiper
        //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //     grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        //     loop: true,
        //     // 如果需要前进后退按钮
        //     // navigation: {
        //     // 	nextEl: '.swiper-button-next',
        //     // 	prevEl: '.swiper-button-prev',
        //     // },
        //     breakpoints: {
        //         375: {
        //             slidesPerView: 2,
        //             spaceBetween: 5,
        //         },
        //         320: {
        //             slidesPerView: 2,
        //             spaceBetween: 15,
        //         },
        //     },
        // });
    },
    methods: {
        toggleTab(current) {
            this.currentTab = current;
            this.currentClass = current;
        },
        detail(id) {
            this.$router.push({
                path: "/productDetails?id=" + id,
            });
        },
        async queryProduct() {
            for (let index = 0; index < this.cmsData.length; index++) {
                let tempList = [];
                this.cmsData[index].optimizationList.map((value) => {
                    tempList.push({
                        id: value.id,
                    });
                });
                let params = {
                    showTerminal: 1,
                    showDesk: 2,
                    list: tempList,
                };
                const res = await queryByProductId(params);
                this.productList.push(res.data);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
//li偶数
.swiper-wrapper li:nth-child(even) {
    border-right: none;
}

//li奇数
.swiper-wrapper li:nth-child(odd) {
    border-left: none;
}

.swiper-wrapper {
    // background: #f7f7f7;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 10px;
}

.container {
    // margin-top: 30px;
    padding-top: 40px;
    // background: #f7f7f7;
}

.tab_button {
    display: flex;
    padding: 0 20px;
}

.tab_button li {
    padding: 10px;
    flex: 1;
    width: 180px;
    /* height: 80px; */
    /* background: #f5f6f5; */
    cursor: pointer;
    display: inline-block;
    //   border-radius: 20px;
    font-size: 33px;
    color: #333;
    font-weight: bold;
    text-align: center;
}

// 1 11 111
.li_img {
    padding: 0 20px;
}

.tab_button li.active {
    color: #dc242f;

    span {
        padding-bottom: 10px;
        border-bottom: 6px #dc242f solid;
    }
}

.swiper-exchange {
    font-size: 18px;
}

// .swiper-item {
//     width: 100%;
//     height: 300px;
//     border-radius: 24px;
//     border: 1px solid #1e53a4;
//     position: relative;
//     display: flex;
//     justify-content: center;
// }

// .swiper-image {
//     width: 100%;
//     height: 100%;
//     box-shadow: 2px 2px 18px rgba(133, 133, 133, 0.34);
// }

.img-back {
    width: 100%;
    height: 80px;
    position: absolute;
    bottom: 0;
}

.pro-img {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 24px;
}

.swiper-bottom {
    width: 100%;
    // height: 80px;
    // position: absolute;
    // bottom: 0;
}

.bottom-content {
    // display: flex;
    // flex-direction: row;
    // align-items: center;
    height: 100%;
}

.bottom-content div {
    flex: 1;
    text-align: center;
    z-index: 2;
    font-size: 28px;

    // color: #fff;
}

.swiper-title {
    margin: 18px auto;
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 28px;
}

// .bottom-content div {
//     flex: 1;
//     z-index: 2;
//     // display: flex;
//     flex-direction: column;
//     font-size: 24px;
// }

.container {
    width: 100%;
    // padding-top: 30px;

    .title {
        color: #333;
        // margin: 0 auto;
        // text-align: center;
        font-size: 28px;
        padding-right: 10px;
    }

    .swiper-slide {
        position: relative;
        width: 50%;
        // display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;

        // background: #fff;
        // border-radius: 30px;
        // padding: 20px;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        // border: 1px #999 solid;
        // padding: 20px;
    }

    .swiper-item {
        background: #fff;
        margin: 15px;
        padding: 20px;
        border-radius: 20px;
    }

    .swiper {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 80px;
        left: 50%;
        transform: translate(-50%, 0);
        color: #fff;
        font-size: 18px;

        .swiper-item {
            margin-bottom: 8px;
        }

        .xian {
            width: 20px;
            margin: 0 auto;
            height: 1px;
            border-bottom: 1px solid #fff;
            margin-bottom: 10px;
        }

        .btn {
            span {
                display: block;
                margin: 0 auto;
                width: 90px;
                height: 20px;
                line-height: 20px;
                font-size: 13px;
                border: 1px solid #fff;
                border-radius: 20px;
            }
        }
    }

    .swiper-container {
        width: 100%;
        // height: 350px;
        margin: 0 auto;
    }
}
</style>
